import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import ClipLoader from 'react-spinners/ClipLoader';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Loader from '../components/Loader';

import { User, Twig, Article } from '../types';
import Cover from './Profile/Cover';
import { createUseStyles } from 'react-jss';
import UserDetails from './Profile/UserDetails';
import TwigCard from '../components/TwigCard';
import { getTwigsByUserID } from '../services/TwigService';
import { useLoadMore } from '../lib/hooks';
import { Helmet } from 'react-helmet';
import { dateFormat, setMetaData } from '../services/helpers';
import { track, pageTrack } from '../services/mixpanelService';
import { RootState } from '../config/store';
import { AuthState } from '../reducers/auth';
import { useSelector } from 'react-redux';
import ArticleCard from '../components/ArticleCard';
import Slider from '../components/Slider';
import Text from '../components/Text';
import { getArticlesById } from '../services/ApiService';

export interface ProfileProps {
  user: User;
}

const Profile: React.FC<ProfileProps> = ({ user }) => {
  const classes = useStyles();
  const [twigs, setTwigs] = useState<Twig[]>([]);
  const [loadingTwigs, setLoadingTwigs] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [doInfiniteScroll, setDoInfiniteScroll] = useState(false);
  const [isMyProfile, setIsMyProfile] = useState(false);
  const [articles,setArticles]=useState<Article[]>([]);
  const [loadingArticles,setLoadingArticles]=useState<boolean>(true);

  const endReached = useLoadMore();
  const { isAuthenticated, user: mainUser } = useSelector<RootState, AuthState>(
    (state) => state.auth,
  );




  useEffect(() => {

    (async () => {
      if (mainUser && mainUser.id == user.id) {
        setIsMyProfile(true)
        pageTrack("profile_screen")
      } else {
        pageTrack("user_profile_screen")
      }
      setLoadingTwigs(true);
      setLoadingArticles(true);

      try {
        const { twigs: response, pagination } = await getTwigsByUserID(
          user.id,
          1,
          10,
        );
        setTwigs(response);
        if (currentPage >= pagination.totalPages) {
          setHasMore(false);
        } else {
          setCurrentPage(currentPage + 1);
        }
        setDoInfiniteScroll(true);
        setLoadingTwigs(false);
        track("profile")

        const articles=await getArticlesById("user_id="+user.id);
        setArticles(articles);
        setLoadingArticles(false);
      } catch (e) { }
    })();
  }, [user, currentPage]);



  // @Todo: refactor this and merge it with the above one
  useEffect(() => {
    if (!doInfiniteScroll || !hasMore || !endReached || loadingMore) return;
    (async () => {
      setLoadingMore(true);
      try {
        const { twigs: response, pagination } = await getTwigsByUserID(
          user.id,
          currentPage,
          10,
        );
        setTwigs([...twigs, ...response]);
        if (currentPage >= pagination.totalPages) {
          setHasMore(false);
        } else {
          setCurrentPage(currentPage + 1);
        }
      } catch (e) { }
      setLoadingMore(false);
    })();
  }, [
    doInfiniteScroll,
    hasMore,
    currentPage,
    endReached,
    loadingMore,
    twigs,
    user,
  ]);
  setMetaData({ "title": user.name + ' twigBIG | Social eCommerce Marketplace in Beauty and Fashion', 'image': user.avatarUrl, 'description': user.about, "url": window.location.href })
  return (
    <>

      <Helmet>
        <title>{user.name}| twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        <meta property="og:description" content={<h1>{user.name}</h1> + '| twigBIG | Social eCommerce Marketplace in Beauty and Fashion'} />
        <script type="application/ld+json">
          {
          `{
          "@context" : "http://schema.org",
          "@type" : "ProfilePage",
          "mainEntity" : {
          "@type" : "Person",
          "name" : "${user.name}",
          "email" : "${user.email}",
          "telephone" : "${user.phoneNumber}",
          "image" : "${user.photo}",
          "url" : "https://twigbig.com/${user.uniqueName}",
          "gender": "${user.gender}"
        }
          }`
        }
        </script>
      </Helmet>
      <Container className={classes.container}>
        <Row>
          <Col>
            <Cover src={user.coverUrl} />
          </Col>
        </Row>
        <Row>
          <Container fluid>
            <Row>
              <Col xs={12} lg={3}>
                <UserDetails user={user} isMyProfile={isMyProfile} />
              </Col>
              <Col xs={12} lg={9}>
                {loadingArticles || articles.length  ? (
                    <div className={classes.articlesBox}>
                      <Loader
                       className={classes.articlesLoader}
                       loading={loadingArticles}
                      center
                      >
                        {()=>(
                        <>
                        <div className={classes.articlesHeader}>
                          <Text bold>Articles</Text>
                        </div>
                        <Slider>
                          {articles.map((article) => (
                            <div
                              key={article.id}
                              className={classes.articleSlideWrapper}
                            >
                              <ArticleCard
                              article={article}
                              />
                            </div>
                            ))}
                        </Slider>
                        </>
                        )}
                      </Loader>
                  </div>
                  ) : (null)}

                  {twigs.length || loadingTwigs ? (
                    <>
                <div className={classes.twigsBox}>
                  <Loader
                    className={classes.twigsLoader}
                    loading={loadingTwigs}
                    center
                  >
                    {() => (
                      <>
                      <Text bold>twigs</Text>
                        <Masonry
                          breakpointCols={{
                            default: 2,
                            700: 1,
                          }}
                          columnClassName=""
                          className={classes.twigsWrapper}
                        >
                          {twigs.map((twig) => (
                            <div key={twig.id} className={classes.twigWrapper}>
                              <TwigCard twig={twig} />
                            </div>
                          ))}
                        </Masonry>
                        <div className={classes.loadingMoreBox}>
                          {loadingMore ? <ClipLoader color="#522583" /> : null}
                        </div>
                      </>
                    )}
                  </Loader>
                </div>
                </>
                  ) : (null) }
                
              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    </>
  );
};

const useStyles = createUseStyles({
  loader: {
    minHeight: '70vh',
  },

  container: {
    marginTop: '30px',
  },
  twigsBox: {
    marginTop: '30px',
  },
  twigsLoader: {
    minHeight: '50vh',
  },
  articlesLoader: {
    minHeight: '50vh',
  },
  twigsWrapper: {
    display: 'flex',
    width: 'auto',
  },
  twigWrapper: {
    margin: '1rem',
    position: 'relative'
  },
  loadingMoreBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
  articlesHeader:{
    display: 'flex',
    justifyContent: 'space-between',
  },
  articleSlideWrapper:{
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '320px',
    display: 'flex !important',
    flexDirection: 'column',
    position: 'relative',
    
  },
  articlesBox:{
    marginTop: '30px',
  },
  
});

export default Profile;
